var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_877_2285",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D052FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_877_2285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 8.80002L8.0998 11.7C7.91647 11.8834 7.68314 11.975 7.3998 11.975C7.11647 11.975 6.88314 11.8834 6.6998 11.7C6.51647 11.5167 6.4248 11.2834 6.4248 11C6.4248 10.7167 6.51647 10.4834 6.6998 10.3L11.2998 5.70002C11.4998 5.50002 11.7331 5.40002 11.9998 5.40002C12.2665 5.40002 12.4998 5.50002 12.6998 5.70002L17.2998 10.3C17.4831 10.4834 17.5748 10.7167 17.5748 11C17.5748 11.2834 17.4831 11.5167 17.2998 11.7C17.1165 11.8834 16.8831 11.975 16.5998 11.975C16.3165 11.975 16.0831 11.8834 15.8998 11.7L12.9998 8.80002V17C12.9998 17.2834 12.904 17.5209 12.7123 17.7125C12.5206 17.9042 12.2831 18 11.9998 18C11.7165 18 11.479 17.9042 11.2873 17.7125C11.0956 17.5209 10.9998 17.2834 10.9998 17V8.80002Z",
    fill: "#D052FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort-up.f3adc6a2878daf5c69d5915606b90803.svg";
export { ForwardRef as ReactComponent };